import { gql } from "@apollo/client";

export const REQUEST_APPLICATION_CONFIGS = gql`
  query requestApplicationConfigs {
    elasticsearchEnabled
    environment
  }
`;
